import React from 'react'
import {FaGithub, FaLinkedin, FaMedium,} from 'react-icons/fa';
import {HiOutlineMail} from 'react-icons/hi';
import {BsFillPersonLinesFill} from 'react-icons/bs';



const SocialLinks = () => {

    const links = [
        {
            id: 1,
            child: (
                <>
                LinkedIn <FaLinkedin size={30}/>        
                </>
            ),
            href: 'https://www.linkedin.com/in/kenneth-the-dev/',
            style: 'rounder-tr-md'
        },
        {
            id: 2,
            child: (
                <>
                Github <FaGithub size={30}/>        
                </>
            ),
            href: 'https://github.com/LoopFruits',  
        },
        {
            id: 3,
            child: (
                <>
                Blog <FaMedium size={30}/>        
                </>
            ),
            href: 'https://medium.com/@Kenneththedev',
        },
        {
            id: 4,
            child: (
                <>
                Mail <HiOutlineMail size={30}/>        
                </>
            ),
            href: 'mailto:kenneththedev@gmail.com',
            style: 'rounder-br-md'
        },
        {
            id: 5,
            child: (
                <>
                Resume <BsFillPersonLinesFill size={30}/>        
                </>
            ),
            href: '/Kenneth Jordan Resume.pdf',
            style: 'rounder-br-md',
            download: true, // allows file download
        },
    ];

  return ( 
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
        <ul>


            {/* looping over  links array */}
            {links.map(({id, child, href, style, download}) => (
                    <li key={id}
                    className={"flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-gray"
                    + 
                    " " +
                    style}>
                <a 
                href={href} 
                className=" flex justify-between items-center w-full text-white"
                download={download}
                target="_blank" //opens a new browser
                rel="noreferrer"
                > 
                    {child}            
                </a>
            </li>
            ))}
      
        </ul>
    </div>
  );
}

export default SocialLinks